// extracted by mini-css-extract-plugin
export default {"Slider_btn":"Button_Slider_btn__4vpdL"};